import Raven from 'raven-js';

const reactAppSentryDsn: string = process.env.REACT_APP_SENTRY_DSN || '';

Raven.config(reactAppSentryDsn).install();

export default Raven;
